import { RainPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/RainPhase';
import { PixelImagesLadyPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/PixelImagesLadyPhase';
import { SquarePathsPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SquarePathsPhase';
import { RandomLerpLinesPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/RandomLerpLinesPhase';
import { SineWaveGridNormalPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineWaveGridNormalPhase';
import { SineWaveGridRandomPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineWaveGridRandomPhase';
import { SineWaveGridWaveyPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineWaveGridWaveyPhase';
import { OrganicLinesPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/OrganicLinesPhase';
import { OrganicLinesQuickPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/OrganicLinesQuickPhase';

import type { PhaseEntry } from 'app/views/home/webgl/particlesOptimised/departments/phases.types';
import type { SpacesContext } from 'app/views/home/webgl/particlesOptimised/departments/spaces/SpacesContext';
import type { SineGridState } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineGridPhase';

/**
 * The spaces show, in order, with timings — THE place to reorder, re-time or
 * add spaces phases. One class per phase lives in ./phases/; `frames` is the
 * phase's duration in frames at 60fps (the department feeds the PhaseRunner
 * a deltaTime-normalised counter). Order and timings are verbatim from the
 * reference stage table (particles/departments/SpacesDepartment.
 * _spacesBoxStages); SpacesDepartment.ts is only the lifecycle shell around
 * this list.
 *
 * The three sine-grid phases share the ONE SineGridState the department
 * hands in — the reference's wave angle carries across those three stages.
 */
export function createSpacesPhaseEntries(ctx: SpacesContext, sineState: SineGridState): Array<PhaseEntry> {
	return [
		{ phase: new RainPhase(ctx), frames: 350 },
		{ phase: new PixelImagesLadyPhase(ctx), frames: 350 },
		{ phase: new SquarePathsPhase(ctx), frames: 300 },
		{ phase: new RandomLerpLinesPhase(ctx), frames: 550 },

		{ phase: new SineWaveGridNormalPhase(ctx, sineState), frames: 200 },
		{ phase: new SineWaveGridRandomPhase(ctx, sineState), frames: 300 },
		{ phase: new SineWaveGridWaveyPhase(ctx, sineState), frames: 300 },

		{ phase: new OrganicLinesPhase(ctx), frames: 640 },
		{ phase: new OrganicLinesQuickPhase(ctx), frames: 360 }
	];
}
